var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.accessories) ? _c('div', {
    staticClass: "product-accessories-view"
  }, [(_vm.accessories.length) ? _c('table', {
    staticClass: "uk-table uk-table-divider uk-margin-remove"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "uk-table-shrink"
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('fields.name')))])])]), _vm._v(" "), _c('draggable', {
    attrs: {
      "options": {
        handle: '.drag-handle'
      },
      "element": "tbody"
    },
    on: {
      "change": _vm.moveAccessory
    },
    model: {
      value: (_vm.accessories),
      callback: function($$v) {
        _vm.accessories = $$v
      },
      expression: "accessories"
    }
  }, _vm._l((_vm.accessories), function(accessory) {
    return _c('tr', {
      key: accessory.id,
      staticClass: "product-accessory-manager__row"
    }, [_c('td', {
      staticClass: "uk-table-shrink"
    }, [_c('drag-handle', {
      attrs: {
        "disabled": _vm.accessories.length <= 1
      }
    })], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'product',
          params: {
            id: accessory.accessoryProduct.id
          }
        }
      }
    }, [_vm._v(_vm._s(accessory.accessoryProduct.name))])], 1), _vm._v(" "), _c('td', [_c('data-grid-actions', {
      attrs: {
        "editable": false
      },
      on: {
        "remove": function($event) {
          _vm.deleteAccessoryWhenConfirmed(accessory)
        }
      }
    })], 1)])
  })), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "uk-padding-remove-left uk-padding-remove-right",
    attrs: {
      "colspan": "3"
    }
  }, [_c('common-button', {
    attrs: {
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$refs.accessoryFormDialog.show()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.add')))])], 1)])])], 1) : _c('div', {
    staticClass: "uk-placeholder uk-text-center uk-margin-remove"
  }, [_c('div', {
    staticClass: "uk-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('hints.empty')))]), _vm._v(" "), _c('common-button', {
    attrs: {
      "icon": "plus",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$refs.accessoryFormDialog.show()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.add')))])], 1), _vm._v(" "), _c('product-accessory-form', {
    ref: "accessoryFormDialog",
    attrs: {
      "errors": _vm.errors,
      "unselectable-product-ids": _vm.unselectableProductIds
    },
    on: {
      "submit": _vm.insertAccessory
    }
  })], 1) : _c('div', {
    staticClass: "uk-margin-medium-top uk-text-center"
  }, [_c('loader')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1041cbb9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/Products/AccessoriesView.vue
// module id = 1858
// module chunks = 0